import { chevronBottom } from "base/SVG";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import styles from "./select-secondary.module.scss";
const SelectSecondary = ({
  selected = null,
  list,
  key = null,
  onChange,
  placeholder,
  size,
}) => {
  const wrapper = useRef(null);
  const [active, setActive] = useState(false);
  const [currentList, setCurrentList] = useState(list);
  const [currentSelected, setCurrentSelected] = useState(selected);

  const onClick = (item) => {
    setCurrentSelected(item);
    if (onChange) onChange(item);

    setActive(false);
  };

  const toggleActive = () => {
    setActive(!active);
  };

  useEffect(() => {
    setCurrentList(
      !currentSelected
        ? list
        : list.filter((item) => {
            let compareKey = key ?? "value";
            return item[compareKey] !== currentSelected[compareKey];
          })
    );
  }, [list, currentSelected]);

  useEffect(() => {
    setCurrentSelected(selected);
  }, [selected]);

  useEffect(() => {
    const windowClick = ({ target }) => {
      if (!wrapper.current.contains(target)) setActive(false);
    };

    if (active) window.addEventListener("click", windowClick);
    else window.removeEventListener("click", windowClick);

    return () => window.removeEventListener("click", windowClick);
  }, [active]);

  return (
    <div
      className={classNames(styles["select"], {
        [styles.active]: active,
        [styles.fixed]: size === "fixed",
      })}
      ref={wrapper}
    >
      <div className={styles["select__selected"]} onClick={toggleActive}>
        {placeholder ? (
          <span>{placeholder}</span>
        ) : (
          <span>{currentSelected ? currentSelected.value : "-----"}</span>
        )}
        {chevronBottom}
      </div>
      <div className={styles["select__options"]}>
        {currentList.map((item, index) => (
          <div
            className={styles["select__option"]}
            key={index}
            onClick={() => onClick(item)}
          >
            {item?.icon && <img src={item.icon} alt="" />}

            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectSecondary;
